export default __webpack_public_path__ + "static/media/patient_info.cf29f938.png";